import type { JSX } from 'react';
import { DrawApi } from '@apply/api';
import DateBox from 'devextreme-react/date-box';
import dayjs from 'dayjs';

interface IEquityMetOnProps {
    onEquityMetOnChange: (newValue: Date) => void;
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
    isReadOnly?: boolean;
}

export const EquityMetOn = ({ drawBudget, isAdmin, onEquityMetOnChange, isReadOnly = false }: IEquityMetOnProps): JSX.Element => {
    return (
        <div>
            {isAdmin ? (
                <>
                    <div title={isReadOnly ? 'This Budget is read only.' : ''}>
                        <label htmlFor='inspectionOrdered'>Equity Met On:</label>
                        <DateBox
                            className='draw-header-input'
                            value={drawBudget?.equityMetOn}
                            onValueChange={(date) => onEquityMetOnChange(date)}
                            disabled={isReadOnly}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Equity Met On:</div>
                    <div>{drawBudget?.equityMetOn ? dayjs(drawBudget?.equityMetOn).format('M/D/YY') : '-'}</div>
                </>
            )}
        </div>
    );
};
